import React, { useState, useEffect } from "react";
import axios from "axios";

const SearchBar = ({ setResults }) => {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      setError(null);
    }
  }, [query, setResults]);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setLoading(true);
    setError(null);

    try {
      const res = await axios.post(`${backendUrl}/api/search`, { query });

      const results = Array.isArray(res.data.response)
        ? res.data.response
        : res.data.response
        ? [res.data.response]
        : [];

      setResults(results);
    } catch (err) {
      setError("Search failed. Please try again.");
      setResults([]);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSearch} className="search-form">
      <input
        type="text"
        className="search-input"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Ask anything..."
        disabled={loading}
        aria-label="Search input"
      />
      <button
        type="submit"
        className="search-button"
        disabled={loading || !query.trim()}
      >
        {loading ? <span className="spinner"></span> : "Search"}
      </button>
      {error && <p className="error-text">{error}</p>}
    </form>
  );
};

export default SearchBar;
